import { defineQuery } from 'next-sanity';

export const HOME_QUERY = defineQuery(`
  *[_type == "home"][0]{
    header,
    heading,
    latestResources[]->{
      _id,
      title,
      publishedAt,
      slug,
      category->{ title },
      author->{ _id, name, image },
      "slug": slug.current,
      preview,
      mainImage{ alt, name, asset },
      tag[]->{ _id, name },
      timeToRead
    }
  }
`);
